import { createSonarSelector } from '@lib/selectors';
import { SonarTag } from '@sonar-software/sonar-core';
import { useSonarSelector } from '@hooks';

const selector = createSonarSelector((state) => state.core.tags.byIdMap);

export function useTagReference(tagId: number | undefined): SonarTag {
	const { data } = useSonarSelector(selector);

	if (!tagId) {
		return {} as SonarTag;
	}

	return data?.[ tagId ] ?? {} as SonarTag;
}
